"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getState = getState;
exports.watchState = watchState;
exports.setState = setState;
const codeQueryParam = new URLSearchParams(location.search).get("code");
const code = codeQueryParam ? decodeURIComponent(atob(codeQueryParam)) : "osc().out()";
const defaultState = {
    editor: code,
    live: code,
    recording: code,
};
let state = Object.assign(Object.assign({}, defaultState), JSON.parse(localStorage.getItem("state") || "{}"));
let listeners = [];
function getState() {
    return state;
}
function watchState(callback) {
    listeners.push(callback);
    return () => {
        listeners = listeners.filter(cb => cb !== callback);
    };
}
function setState(newState) {
    const updated = Object.assign(Object.assign({}, state), newState);
    if (JSON.stringify(state) !== JSON.stringify(updated)) {
        state = updated;
        localStorage.setItem("state", JSON.stringify(state));
        listeners.forEach(cb => cb(state));
    }
}
